export default {
    title: 'Verifikacija broja telefona',
    verificationDescription: 'Da bismo mogli da vam pružimo najbolju uslugu neophodna je verfiikacija mobilnog broja neke crnogorske mreže.',
    back: 'Nazad',
    phoneInput : {
        label: 'Broj telefona',
        placeholder: '067/067-067'
    },
    button : {
        sendCode: {
            'title' : 'Pošalji kod',
            'infoAlert' : 'Nakon što kliknete na dugme Pošalji kod, stići će vam kod koji unosite na sledećoj stranici.'
        },
        confirmCode: {
            'title' : 'Potvrdi',
            'infoAlert' : 'Svoje preference za notifikacije možete podesiti u podešavanjima Vašeg profila.'
        },
        skip: 'Preskoči'
    },
    enterRecievedCode: 'Unesite kod koji smo poslali na:',
    codeInput: {
        label: 'Kod',
        placeholder: '****'
    },
    resend: 'Pošalji opet',
    swal: {
        areYourSure: 'Da li ste sigurni?',
        weWillSendCodeTo: 'Poslaćemo kod na:',
        yes: 'Da',
        no: 'Ne',
        whyDidThisHappen: 'Zbog čega je došlo do ovoga?'
    }
};
